import React from 'react';

import BaseTimePicker from 'antd/es/time-picker';

const TimePicker = ({ style = {}, ...rest }) => (
  <BaseTimePicker.RangePicker
    format={'HH:mm'}
    showSecond={false}
    order={false}
    style={{
      width: '215px',
      minWidth: '215px',
      maxWidth: '265px',
      ...style,
    }}
    {...rest}
  />
);

export default TimePicker;
